export default __webpack_public_path__ + "static/company_league-296b8a22b1174f09ca229e1f6b150832.svg";